import React from 'react'
import "../styles/index.scss"
import IssuesManagementPage from './IssuesManagementPage'

const ID_SUPPLIER_1C = "5cf099aa3b7f1e3d46b7ae73"

const IssuesManagementContainer = () => {

    return (
        <div className='IssuesManagementContainer'>
            <IssuesManagementPage idSupplier={ID_SUPPLIER_1C}/>
        </div>
    )
}

export default IssuesManagementContainer